export default __webpack_public_path__ + "static/media/fontawesome-webfont3e6e.f691f37e.woff";